<section class="ru mt-2">
  <header class="ru-head">
    <div class="ru-id">
      <h2 class="ru-title">Review upload</h2>
      <p class="ru-meta">
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
        {{ result.source }} &middot; {{ result.sheet }} sheet
        <ng-container *ngIf="uploadedAt"> &middot; uploaded {{ uploadedAt }}</ng-container>
        <ng-container *ngIf="uploadedBy"> by {{ uploadedBy }}</ng-container>
      </p>
    </div>
    <span class="pill" [ngClass]="badge.cls">{{ badge.text }}</span>
  </header>

  <dl class="stats">
    <div><dt>Rows</dt><dd>{{ result.summary.rows }}</dd></div>
    <div><dt>Accepted</dt><dd class="ok">{{ result.summary.accepted }}</dd></div>
    <div><dt>Rejected</dt><dd [class.err]="result.summary.rejected > 0">{{ result.summary.rejected }}</dd></div>
    <div><dt>Schedules</dt><dd>{{ result.summary.schedules }}</dd></div>
    <div><dt>Warnings</dt><dd class="warn">{{ warningCount }}</dd></div>
  </dl>

  <!-- Schedules -->
  <h3 class="ru-h">Schedules to be created</h3>
  <div class="table-wrap">
    <table class="grid">
      <thead>
        <tr>
          <th scope="col">Schedule</th>
          <th scope="col">Window (IST)</th>
          <th scope="col" class="num">Instances</th>
          <th scope="col">Accounts</th>
          <th scope="col">Notices</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of schedules; trackBy: trackSchedule">
          <td>
            <div class="link brk">{{ s.schedule_id }}</div>
            <div class="muted">Slot {{ s.slots.join(', ') }}<ng-container *ngIf="owners(s)"> &middot; {{ owners(s) }}</ng-container></div>
          </td>
          <td>
            <div>{{ windowText(s) }}</div>
            <div class="muted">{{ rebootText(s) }}</div>
          </td>
          <td class="num">{{ s.instance_count }}</td>
          <td>
            <div *ngFor="let g of s.run_groups" class="acct">
              <span class="mono">{{ g.account_id }}</span>
              <span class="muted">{{ g.region }}</span>
            </div>
          </td>
          <td>
            <span class="pill pill-warn" *ngIf="missed(s) > 0">{{ missed(s) }} missed</span>
            <span class="pill pill-ok" *ngIf="missed(s) == 0">On time</span>
          </td>
        </tr>
        <tr *ngIf="schedules.length == 0">
          <td colspan="5" class="empty">No valid schedules were found in this file.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Issues -->
  <div class="issues-head">
    <h3 class="ru-h">Issues</h3>
    <span class="pill pill-err">{{ errorCount }} error{{ errorCount == 1 ? '' : 's' }}</span>
    <span class="pill pill-warn">{{ warningCount }} warning{{ warningCount == 1 ? '' : 's' }}</span>
    <!-- <button type="button" class="btn-outline btn-sm push" *ngIf="issues.length > 0" (click)="downloadIssues()">
      <i class="fa fa-download" aria-hidden="true"></i> Download issues
    </button> -->
  </div>

  <div class="table-wrap" *ngIf="issues.length > 0; else noIssues">
    <table class="grid issues">
      <thead>
        <tr>
          <th scope="col">Severity</th>
          <th scope="col" class="num">Row</th>
          <th scope="col">Instance</th>
          <th scope="col">Message</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let i of issues; trackBy: trackIssue">
          <td><span class="pill" [ngClass]="i.severity == 'error' ? 'pill-err' : 'pill-warn'">{{ i.severity }}</span></td>
          <td class="num">{{ i.row }}</td>
          <td>
            <div>{{ i.name }}</div>
            <div class="muted mono brk">{{ i.instance_id }}</div>
          </td>
          <td class="msg">{{ i.message }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #noIssues><p class="muted">No issues found.</p></ng-template>

  <p class="note">
    <i class="fa fa-info-circle" aria-hidden="true"></i>
    Publishing schedules these windows and notifies stakeholders. Rows with errors are left out;
    fix them in the Excel and upload again.
  </p>

  <footer class="actions">
    <button type="button" class="btn-outline" [disabled]="busy != 'idle'" (click)="uploadCorrected.emit()">
      <i class="fa fa-upload" aria-hidden="true"></i> Upload corrected file
    </button>
    <button type="button" class="btn-outline" [disabled]="busy != 'idle'" (click)="discard.emit()">Discard</button>
    <button type="button" class="btn-primary" [disabled]="!canPublish" (click)="publish.emit()">
      <i class="fa fa-paper-plane" aria-hidden="true"></i> {{ publishLabel }}
    </button>
  </footer>
</section>